export const apiConstants = {
  referrersDetails: 'Referral/ReferrersDetails?searchToken=',
  MemberSummary: 'Member/MemberSummary',
};
